export default __webpack_public_path__ + "static/media/webstack.7892fcb2.svg";